export default {
  id: 'subcontractors',
  title: 'Subcontractors & Subcontracts',
  category: 'Admin',
  summary: 'Manage subcontractor companies, their employees, and subcontract agreements.',
  overview: 'Subcontractor records track external companies that perform work. Subcontracts define the agreements under which that work is performed, often in relation to prime contracts.',
  howItWorks: [
    'Create a subcontractor organization, then add subcontractor employees as needed.',
    'Create subcontracts to capture commercial terms for subcontractor work.',
    'Detail pages manage ongoing attributes and relationships.'
  ],
  actions: [
    {
      name: 'Create subcontractor',
      description: 'Adds a subcontractor company record.'
    },
    {
      name: 'Add subcontractor employees',
      description: 'Associates people with the subcontractor for tracking and assignment.'
    },
    {
      name: 'Create / edit subcontract',
      description: 'Maintains the subcontract agreement details linked to your contracting structure.'
    }
  ],
  tips: [
    'Keep subcontractor employee records distinct from prime-company employees when reporting labor.'
  ],
  related: ['contracts', 'employees', 'projects']
};



// WEBPACK FOOTER //
// ./client/help/content/subcontractors.js